import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, FileText, MapPin, Globe, Mail, Briefcase, Calendar, ShieldCheck } from 'lucide-react';
import { TranslatedText } from '@/components/TranslatedText';

const rows = [
  { icon: FileText, label: 'License No.', value: '87988' },
  { icon: ShieldCheck, label: 'Legal Form', value: 'FZCO' },
  { icon: Calendar, label: 'Issued', value: '06/05/2026' },
  { icon: Calendar, label: 'Valid Until', value: '05/05/2027' },
  { icon: Building2, label: 'Issuing Authority', value: 'Dubai Integrated Economic Zones Authority (DIEZ) — IFZA' },
  { icon: MapPin, label: 'Registered Address', value: 'DSO-IFZA, IFZA Properties, Dubai Silicon Oasis, Dubai, United Arab Emirates' },
  { icon: Briefcase, label: 'Licensed Activities', value: 'Portal, Marketing Management, Project Management Services, E-commerce' },
];

const Company = () => {
  return (
    <>
      <Helmet>
        <title>Company Information | Faceless Aura Club</title>
        <meta name="description" content="Legal entity, license, and holding company information for Faceless Aura Club, operated by AURADYNAMICS PROJECT MANAGEMENT SERVICES - FZCO." />
      </Helmet>

      <div className="min-h-screen bg-slate-50">
        <div className="max-w-3xl mx-auto px-4 py-10 sm:py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900 mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <TranslatedText>Back to Home</TranslatedText>
          </Link>

          <div className="mb-10">
            <p className="text-xs uppercase tracking-[0.2em] text-blue-600 font-semibold mb-3">
              <TranslatedText>Company Information</TranslatedText>
            </p>
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
              <TranslatedText>About the Company Behind Faceless Aura Club</TranslatedText>
            </h1>
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              <TranslatedText>Faceless Aura Club is a brand operated by AURADYNAMICS PROJECT MANAGEMENT SERVICES - FZCO, a licensed entity registered in the United Arab Emirates under the Dubai Integrated Economic Zones Authority (IFZA).</TranslatedText>
            </p>
          </div>

          <div className="rounded-2xl bg-white border border-slate-200 shadow-sm overflow-hidden">
            <div className="p-6 sm:p-8 border-b border-slate-100 bg-gradient-to-br from-blue-50 to-white">
              <p className="text-xs uppercase tracking-wider text-slate-500 mb-2">
                <TranslatedText>Legal Entity</TranslatedText>
              </p>
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900">
                AURADYNAMICS PROJECT MANAGEMENT SERVICES - FZCO
              </h2>
            </div>

            <dl className="divide-y divide-slate-100">
              {rows.map(({ icon: Icon, label, value }) => (
                <div key={label} className="px-6 sm:px-8 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6">
                  <dt className="flex items-center gap-2 text-sm font-medium text-slate-500 sm:w-56 shrink-0">
                    <Icon className="w-4 h-4 text-blue-600" />
                    <TranslatedText>{label}</TranslatedText>
                  </dt>
                  <dd className="text-slate-900 text-sm sm:text-base break-words">
                    <TranslatedText>{value}</TranslatedText>
                  </dd>
                </div>
              ))}

              <div className="px-6 sm:px-8 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6">
                <dt className="flex items-center gap-2 text-sm font-medium text-slate-500 sm:w-56 shrink-0">
                  <Globe className="w-4 h-4 text-blue-600" />
                  <TranslatedText>Holding Company</TranslatedText>
                </dt>
                <dd className="text-sm sm:text-base break-words">
                  <a
                    href="https://auradynamics.management"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-700 underline underline-offset-2 font-medium"
                  >
                    auradynamics.management
                  </a>
                </dd>
              </div>

              <div className="px-6 sm:px-8 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6">
                <dt className="flex items-center gap-2 text-sm font-medium text-slate-500 sm:w-56 shrink-0">
                  <Mail className="w-4 h-4 text-blue-600" />
                  <TranslatedText>Contact</TranslatedText>
                </dt>
                <dd className="text-sm sm:text-base break-words">
                  <a
                    href="mailto:hello@auradynamics.management"
                    className="text-blue-600 hover:text-blue-700 underline underline-offset-2 font-medium"
                  >
                    hello@auradynamics.management
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <p className="text-xs text-slate-500 mt-6 text-center">
            <TranslatedText>For legal notices, terms, and privacy details, please see our</TranslatedText>{' '}
            <Link to="/legal" className="text-blue-600 hover:underline"><TranslatedText>Legal Notice</TranslatedText></Link>.
          </p>
        </div>
      </div>
    </>
  );
};

export default Company;
